import axios from './_nestAxios'

export const login = async info => {
  const { data } = await axios.post('/auth/login', info)
  return data
}

export const cambiarAnioTrabajo = data => axios.put('/auth/cambiar-anio', data)
export const cambiarMesTrabajo = data => axios.put('/auth/cambiar-mes', data)
export const cambiarFechaTrabajo = data => axios.put('/auth/cambiar-fecha-trabajo', data)
export const cambiarCompania = data => axios.put('/auth/cambiar-compania', data)
export const cambiarSede = data => axios.put('/auth/cambiar-sede', data)

export const getSesionInfo = () => axios.get('/auth/sesion-info')
export const getCompaniasHabilitadas = () => axios.get('/auth/companias-habilitadas')
export const getSedesHabilitadas = () => axios.get('/auth/sedes-habilitadas')
export const obtenerCompaniaLogo = () => axios.get('/auth/obtener-compania-logo')
export const obtenerCompaniaLogoEdicion = () => axios.get('/auth/obtener-compania-logo-edicion')
